import { Volume2, VolumeX } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { artAssets } from "../data/site";
import { NewsletterForm } from "./NewsletterForm";
import { Reveal } from "./Reveal";

export function NewsletterSection() {
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = true;
    video.play().catch(() => {});
  }, []);

  const toggleMute = async () => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = !muted;
    setMuted(video.muted);
    if (!video.muted) {
      try {
        await video.play();
      } catch {
        video.muted = true;
        setMuted(true);
      }
    }
  };

  return (
    <section className="newsletter-section" data-testid="newsletter-section">
      <Reveal className="signal-video-shell">
        <div className="signal-video-frame">
          <video
            ref={videoRef}
            className="signal-video"
            autoPlay
            muted={muted}
            loop
            playsInline
            preload="auto"
            aria-label="Dolo Wasteland Runner closing transmission video"
            data-testid="newsletter-signal-video"
          >
            <source src={artAssets.finalSectionVideoWebm} type="video/webm" />
            <source src={artAssets.finalSectionVideo} type="video/mp4" />
          </video>
          <button
            type="button"
            className="video-mute-button signal-video-mute"
            onClick={toggleMute}
            data-testid="newsletter-video-mute-button"
            aria-label={muted ? "Unmute closing transmission" : "Mute closing transmission"}
            aria-pressed={!muted}
          >
            {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
            <span>{muted ? "MUTED" : "SOUND ON"}</span>
          </button>
        </div>
        <div className="signal-video-caption">
          <span>CLOSING TRANSMISSION</span>
          <strong>BLACK-OPS NET SIGNAL / 00:10 LOOP</strong>
        </div>
      </Reveal>
      <Reveal className="terminal-shell">
        <div className="terminal-header">
          <span />
          <span />
          <span />
          <strong>BLACK-OPS NET / UPLINK</strong>
        </div>
        <NewsletterForm />
      </Reveal>
    </section>
  );
}
